export default __webpack_public_path__ + "static/media/network-icon.056aadf0.svg";